import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import PropTypes from 'prop-types';

import Icons from 'consts/icons';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { addAlert } from 'store/actions/alert/alerts';
import { connect, useDispatch } from 'react-redux';
import { patchRequest } from 'helpers/apiRequests';
import { setLanguage } from 'store/actions/language/language';
import { useParams, useHistory } from 'react-router-dom';
import { useLoginStyles } from 'consts/styles/Login';
import ButtonsUseStyles from 'consts/styles/Buttons';

import Copyright from './Copyright';

const PasswordReset = props => {
  const { language } = props;

  const dispatch = useDispatch();

  const [siteLang, setSiteLang] = React.useState('en');
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);

  const { uidb64, token } = useParams();

  const history = useHistory();

  const changeLanguage = () => {
    const langToShow = siteLang === 'pl' ? 'en' : 'pl';
    setSiteLang(langToShow);
    dispatch(setLanguage(langToShow));
  };

  const [values, setValues] = React.useState({
    password: '',
    rePassword: '',
  });

  const classes = useLoginStyles();
  const classesButtons = ButtonsUseStyles();

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    setError(false);
    setValues({
      ...values,
      [name]: value,
    });
  };

  const validate = () => {
    if (values.password === values.rePassword) return true;
    setError(true);
    return false;
  };

  const setPassword = () => {
    if (!validate()) return;
    patchRequest('setNewPassword', {
      password: values.password,
      token,
      uidb64,
    })
      .then(result => {
        if (result.status === 200) setShowSuccessMessage(true);
        else setErrorMsg(true);
        dispatch(
          addAlert({
            title: language.alerts.dataProccessError.title_,
            desc: result.response.data.error
              ? result.response.data.error
              : result.message,
            type: 'error',
          })
        );
      })
      .catch(error => {
        setErrorMsg(true);
        dispatch(
          addAlert({
            title: language.alerts.loginError.title_,
            desc: error.message,
            type: 'error',
          })
        );
      });
  };

  const handleEnterClick = event => {
    if (event.key === 'Enter') {
      setPassword();
    }
  };

  const handleErrors = () => {
    if (showSuccessMessage) {
      return (
        <>
          <Alert
            severity="success"
            className={`${classes.Login}__message ${classes.Login}__message--border--success`}
          >
            {language.resetPassword.emailPage.successMsg_}
          </Alert>
        </>
      );
    }
    if (errorMsg) {
      return (
        <>
          <Alert
            severity="error"
            className={`${classes.Login}__message ${classes.Login}__message--border--error`}
          >
            {language.alerts.loginError.desc_}
          </Alert>
        </>
      );
    }
    return (
      <Paper
        className={`${classes.Login}__message ${classes.Login}__message--hidden`}
      >
        &nbsp;
      </Paper>
    );
  };

  const handleLogin = () => {
    history.push('/login');
  };

  return (
    <div className={classes.Login}>
      <Button
        className={`${classes.Login}__lang ${classesButtons.ButtonsClose}--login-page ${classesButtons.ButtonsClose} ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
        onClick={() => changeLanguage()}
      >
        <Icons.Misc.Language className={`${classes.Login}__lang__icon`} />
        &nbsp;&nbsp;
        <div className={`${classes.Login}__lang__text`}>
          {siteLang === 'pl' ? 'PL' : 'EN'}
        </div>
      </Button>
      <Container
        className={`${classes.Login}__container`}
        component="main"
        maxWidth="xs"
      >
        <CssBaseline />
        <div className={`${classes.Login}__container__paper`}>
          <Avatar className={`${classes.Login}__container__paper__avatar`}>
            <Icons.Misc.LocalAirport />
          </Avatar>
          <Typography component="h1" variant="h5">
            {language.resetPassword.setPassword.header_}
          </Typography>
          <form
            className={`${classes.Login}__container__paper__form`}
            noValidate
          >
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              error={error}
              id="password"
              label={language.resetPassword.setPassword.password_}
              name="password"
              autoComplete="password"
              type="password"
              autoFocus
              onChange={handleChange}
              onKeyPress={handleEnterClick}
              value={values.password}
              InputLabelProps={{
                classes: {
                  outlined: `${classes.Login}__container__paper__form__outlined--color`,
                },
              }}
              InputProps={{
                classes: {
                  input: `${classes.Login}__container__paper__form__outlined--color`,
                  notchedOutline: `${classes.SignIn}__container__paper__form__outlined--border`,
                },
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              error={error}
              id="rePassword"
              label={language.resetPassword.setPassword.rePassword_}
              name="rePassword"
              type="password"
              onChange={handleChange}
              onKeyPress={handleEnterClick}
              value={values.rePassword}
              InputLabelProps={{
                classes: {
                  outlined: `${classes.Login}__container__paper__form__outlined--color`,
                },
              }}
              InputProps={{
                classes: {
                  input: `${classes.Login}__container__paper__form__outlined--color`,
                  notchedOutline: `${classes.SignIn}__container__paper__form__outlined--border`,
                },
              }}
            />
            <Grid className={`${classes.Login}__container__paper__form--hr`}>
              &nbsp;
            </Grid>
            <Button
              type="button"
              fullWidth
              className={`${classes.Login}__container__paper__form__submit`}
              onClick={setPassword}
            >
              {language.resetPassword.setPassword.button_}
            </Button>
            <Grid
              container
              className={`${classes.Login}__login-page--padding-bottom`}
            >
              <Grid item xs>
                <Link
                  variant="body2"
                  onClick={handleLogin}
                  className={`${classes.Login}--cursor`}
                >
                  <Icons.Navigation.BackToLogIn />
                  &nbsp;&nbsp;{language.resetPassword.emailPage.backMsg_}
                </Link>
              </Grid>
            </Grid>
            {handleErrors()}
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </div>
  );
};

PasswordReset.propTypes = {
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(PasswordReset);
